import { EntityStore } from 'shared/stores/EntityStore';

class ClientChangelogStore extends EntityStore {
	entityPluralEndpoint = 'clients/changelog';
	constructor() {
		super('client-changelog');
	}

	typeOptions = [
		{ text: 'Name', value: 'name' },
		{ text: 'URL', value: 'url' },
		{ text: 'Account Manager', value: 'accountManagerId' },
		{ text: 'Industry', value: 'industry' },
		{ text: 'Size', value: 'size' },
		{ text: 'Country', value: 'countryId' },
		{ text: 'City', value: 'city' },
		{ text: 'LinkedIn', value: 'linkedin' },
		{ text: 'LinkedIn URL', value: 'linkedinUrl' },
		{ text: 'Website', value: 'website' },
		{ text: 'Additional Infos', value: 'additionalInfos' },
		{ text: 'Profile Image', value: 'profileImage' },
		{ text: 'Technologies', value: 'technologies' },
		{ text: 'Job Roles', value: 'jobRoles' },
		{ text: 'Client Contacts', value: 'clientContacts' }
	];
}

export const clientChangelogStore = new ClientChangelogStore();
